import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import React, { useEffect, useState,useRef } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import Sonnet from "../../src/components/sonnet";
import { toast } from "react-toastify";
import Login from "./Login";
import { useNavigate } from "react-router-dom";
import StripeElement from "./StripeElement";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import states from "states-us";
import debounce from "lodash.debounce";
import InputMask from "react-input-mask";
import {useAuthUser} from "../customHooks/useAuthUser";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg"
import DownArrow from "../assets/svg/downArrow";
import WalletSvg from "../assets/svg/walletSvg";
import ClockSvg from "../assets/svg/clockSvg";

function UncontrolledExample(props) {
  const loggedInUser = useAuthUser();
  const location = useLocation();
  const prams = useParams();

  const isLoggedInUserAdmin = loggedInUser?.role == "admin" ? true : false;
  const [updateBidAmount, setUpdateBidAmount] = useState(
    location?.state?.bidamount ? location.state?.bidamount : 0
  );
  const [updating, setUpdating] = useState(false);
  const navigate = useNavigate();
  const [Show, setShow] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(false);
  const [value, setvalue] = useState(0);
  const [sales, setSales] = useState(0);
  const [processing, setProcessing] = useState(0);
  const [returnFee , setReturnFee] = useState(0);
  const [total, setTotal] = useState(0);
  const [Finalchecks, setFinalchecks] = useState();
  const [Finalchecks1, setFinalchecks1] = useState();
  // const [Finalchecks2, setFinalchecks2] = useState();
  const [NoCancelError, setNoCancelError] = useState(false);
  const [AcceptedError, setAcceptedError] = useState(false);
  const [Finalchecks1Error1, setFinalchecks1Error1] = useState(false);
  const [returnFeeError, setReturnFeeError] = useState(false);
  const [input, setInput] = useState(false);
  const [showCardModel, setShowCardModel] = useState(false);
  const [userAsk, setUserAsk] = useState(true);
  const [askAmount, setAskAmount] = useState();
  const [bidAmount, setBidAmount] = useState();
  const [shippingFee, setShippingFee] = useState();
  const [buyNowStatus, setBuyNowStatus] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [popup, setPopup] = useState(false);
  const [cardExpiry, setCardExpiry] = useState("");
  const [cardBrand, setCardBrand] = useState("");
  const [fullPageLoader, setFullPageLoader] = useState(false);
  const [bidStatus, setBidStatus] = useState(false);
  const [showTaxesDetails, setShowTaxesDetails] = useState(false);
  const [carddetails, setCarddetails] = useState("");
  const [street, setStreet] = useState();
  const [city, setCity] = useState();
  const [country, setCountry] = useState();
  const [state, setState] = useState();
  const [postalCode, setPostalCode] = useState();
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [validStreet, setValidStreet] = useState();
  const [validCity, setValidCity] = useState();
  const [validState, setValidState] = useState();
  const [validcountry, setValidCountry] = useState("United States");
  const [validPostalCode, setValidPostalCode] = useState();
  const [buttonAddressLoader, setButtonAddressLoader] = useState(false);
  const [primaryAccountModel, setPrimaryAccountModel] = useState(false);
  const [tax, setTax] = useState(7.25);
  const [mobileNumber, setMobileNumber] = useState();
  const [paymentbtn, setPaymentbtn] = useState();
  const [shippingrates, setShippingRates] = useState(0);
  const [estimatedShippingRate , setEstimatedShippingRate] = useState(false);
  const [shippingrateid, setShippingRateId] = useState();
  const [shiploader, setShipLoader] = useState(false);
  const [salesTaxLoader, setSalesTaxLoader] = useState(false)
  const [bidvalue, setBidValue] = useState("")
  const [usershipaddress, setUsershipaddress] = useState({
    street: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    phone: "",
  });
  const [intialdata, setIntialdata] = useState();
  const [addReturn, setAddReturn] = useState(false);
  const [noThanks, setNoThanks] = useState(false);
  const [rememberSelections, setRememberSelections] = useState(false);

  // Constants for localStorage
  const SELECTIONS_STORAGE_KEY_PREFIX = "bidtab_user_selections";
  const SELECTIONS_VERSION = "1.0"; // Increment this when policies/wording change
  
  // Get storage key (global, not per URL)
  const getStorageKey = () => {
    return `${SELECTIONS_STORAGE_KEY_PREFIX}_global`;
  };


    useEffect(() => {
  
      const restoreAskValues = () => {
        const storedData = localStorage.getItem("bidSummary");
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          handlePlaceBidValue(parsedData.bidAmount);
        }
      };
  
      // run once on mount
      restoreAskValues();
  
      // run again after login
      window.addEventListener("handlingUserAction", restoreAskValues);
  
      return () => {
        window.removeEventListener("handlingUserAction", restoreAskValues);
        localStorage.removeItem("bidSummary");
      };
    }, []);

  useEffect(() => {
    if (!value || value <= 0) return;
    const returnFeeCal = !addReturn || isLoggedInUserAdmin ? 0 : (value / 100) * 8;
    setReturnFee(returnFeeCal?.toFixed(2));
  }, [addReturn, value, loggedInUser])

  const stateRef = useRef(null);
  const isInitialLoad = useRef(true);

  const [activeKey, setActiveKey] = useState(() => {
    const storedTab = localStorage.getItem("activeTab");

    if (storedTab) {
      return "home";
    }

    if (prams.buy === "buy" || updateBidAmount || prams.buy === undefined) {
      return "profile";
    }

    return "home";
  });

  useEffect(() => {
    const storedTab = localStorage.getItem("activeTab");
    if (storedTab) {
      setActiveKey("home");

    }
    if (prams.buy === "buy" || updateBidAmount || prams.buy === undefined) {
      setActiveKey("profile");
    } else {
      setActiveKey("home");
    }
  }, [prams, updateBidAmount]);


  // Toggle taxes-detail class

  const shippingValue = value === 0 || value === "" || isNaN(value) ? 0 : 25;

  const toggleTaxesDetails = () => {
    setShowTaxesDetails(!showTaxesDetails);
  };

  useEffect(() => {
    // remove after 2s delay instead of immediately
    const timer = setTimeout(() => {
      localStorage.removeItem("activeTab");
    }, 2000);

    // cleanup in case component unmounts
    return () => clearTimeout(timer);
  }, []);

  // Restore selections from localStorage on component mount
  useEffect(() => {
    loadSelectionsFromStorage();
    // Mark initial load as complete after a short delay
    setTimeout(() => {
      isInitialLoad.current = false;
    }, 100);
  }, []);

  // Auto-save to localStorage when Finalchecks, Finalchecks1, addReturn, noThanks, or rememberSelections changes
  useEffect(() => {
    // Skip saving on initial load (when restoring from localStorage)
    if (isInitialLoad.current) {
      return;
    }
    
    // Only save if rememberSelections is true
    if (rememberSelections) {
      // Use setTimeout to ensure state is fully updated before saving
      const timer = setTimeout(() => {
        saveSelectionsToStorage(true);
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [Finalchecks, Finalchecks1, addReturn, noThanks, rememberSelections]);

  const hendleBid = () => {
  setLoading(true);
  
  if (!loggedInUser) {
    setLoading(false);
    setShowModal(true);
    return;
  }

  // ✅ Check bidStatus and Ask
  if (bidStatus && props.Ask !== undefined) {
    const numericValue = Number(value);

    if (numericValue === props.Ask) {
      toast.error("Your bid matches the highest ask.");
      setLoading(false);
      return;
    } else if (numericValue > props.Ask) {
      toast.error("Your bid is higher than the highest ask.");
      setLoading(false);
      return;
    }
  }

  // ✅ Check Return Fee Selection
  if (!addReturn && !noThanks) {
    setReturnFeeError(true);
    toast.error("Complete necessary checkboxes for seamless shopping");
    setLoading(false);
    return;
  } else {
    setReturnFeeError(false);
  }

  // ✅ Check Final Conditions
  if (!Finalchecks) {
    setNoCancelError(true);
    toast.error("Complete necessary checkboxes for seamless shopping");
    setLoading(false);
    return;
  } else {
    setNoCancelError(false);
  }

  if (!Finalchecks1) {
    setAcceptedError(true);
    toast.error("Complete necessary checkboxes for seamless shopping");
    setLoading(false);
    return;
  } else {
    setAcceptedError(false);
  }

  // if (!Finalchecks2) {
  //   setFinalchecks1Error1(true);
  //   toast.error("Complete necessary checkboxes for seamless shopping");
  //   setLoading(false);
  //   return;
  // } else {
  //   setFinalchecks1Error1(false);
  // }

  const user = loggedInUser

  // ✅ Final Confirmation & Action
  if (input) {
    setLoading(false);
    return;
  }

  const confirmOrder = window.confirm("Are you sure you want to create order?");
  if (!confirmOrder) {
    setLoading(false);
    return;
  }

  setLoading(true);
  handleUserAsk(user.id);
};

  useEffect(() => {

    const fetchRates = async (amount) => {
      const signChargeEnabled = Number(value) >= 1000 ? true : false;
      ExportApi.getshipmentrates(loggedInUser?.id, amount , signChargeEnabled , "bid")
        .then((res) => {
          if (res?.data?.success) {
            setShippingRates(res?.data?.amount);
            setShippingRateId(res?.data?.object_id);
            handlePlaceBidValue(value);
            setShipLoader(false);
          }
          else {
            setShippingRates(12);
            setShippingRateId(null)
            setShipLoader(false);
            setEstimatedShippingRate(true)
          }
          
        })
        .catch((err) => {
          console.log(err);
          setShipLoader(false);
        });
    };

    const fetchSalesTax = async (amount) => {
      ExportApi.getSalesTax(amount, loggedInUser?.id)
        .then((res) => {
          if (res?.data?.success) {
            setSales(res?.data?.data?.taxAmount || 0)
          }
          else {
            toast.error(res?.data?.message)
          }
          setSalesTaxLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setSalesTaxLoader(false);
        });
    };

    // Debounced function to fetch rates
    const debouncedFetchRates = debounce(async (amount) => {
      setLoading(true);
      try {
        await Promise.all([
          fetchRates(amount),
          fetchSalesTax(amount),
        ]);
      } catch (err) {
        console.error(err);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }, 3000);

    if (loggedInUser && loggedInUser?.role !== "admin" && value > 0) {
      setShipLoader(true);
      setSalesTaxLoader(true);
      setEstimatedShippingRate(false);
      debouncedFetchRates(value);  // Call the debounced function
    } else if (loggedInUser && loggedInUser?.role == "admin" && value > 0) {
      setShipLoader(false);
      setSalesTaxLoader(false);
      setShippingRates(0);
      setSales(0);
      setEstimatedShippingRate(false);
      handlePlaceBidValue(value);
    } else if (!loggedInUser && value && value > 0) {
      setShipLoader(false);
      setSalesTaxLoader(false);
      setShippingRates(12);
      setSales(0);
      setEstimatedShippingRate(true);
      handlePlaceBidValue(value);
    }
    else {
      setShipLoader(false);
      setSalesTaxLoader(false);
      setShippingRates(null);
      setSales(null);
      setEstimatedShippingRate(false);

    }

    return () => {
      debouncedFetchRates.cancel();  // Cleanup the debounce function
    };

  }, [value , loggedInUser]);

  const handlePlaceOrder = () => {
    setLoading(true); // Set the loader to true initially

    if (loggedInUser) {
        if ((addReturn || noThanks) && Finalchecks && Finalchecks1 ) { // && Finalchecks2
          setReturnFeeError(false);
          setNoCancelError(false);
          setAcceptedError(false);
          setFinalchecks1Error1(false);

          if (loggedInUser) {
            if (!input) {
              let confirm = window.confirm(
                "Are you sure you want to create order"
              );
              if (!confirm) {
                setLoading(false); // Stop the loader if the user cancels the confirmation
              } else {
                handleUserAsk(loggedInUser?.id);
              }
            } else {
              setLoading(false); // Stop the loader if input is present
            }
          } else {
            setLoading(false); // Stop the loader if neither tokenuser nor admin is present
            setShowModal(true);
          }
        } else {
          setLoading(false); // Stop the loader if necessary checkboxes are not completed
          if (!addReturn && !noThanks) {
            setReturnFeeError(true);
          }
          if (!Finalchecks) {
            setNoCancelError(true);
          }
          if (!Finalchecks1) {
            setAcceptedError(true);
          }
          // if (!Finalchecks2) {
          //   setFinalchecks1Error1(true);
          // }
          toast.error("Complete necessary checkboxes for seamless shopping");
        }
      //  }
    } else {
      setLoading(false); // Stop the loader if no tokenuser or admin is present
      setShowModal(true);
    }
  };

  //function for creating New Products
  //productId used for the productId
  //userId used for the UserId
  const handleCreateOrder = (productId, userId) => {
    setLoading(true);
    ExportApi.createOrder(productId, userId, total)
      .then((response) => {
        setLoading(false);
        navigate("/order");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Function for creating 2nd Hand
  //Value is the input value of the bid
  const handleCreateSecondHandOrder = (productId, userId, value) => {
    setLoading(true);
    ExportApi.CreateSecondHandOrder(
      productId,
      userId,
      value,
      "Buy",
      props?.Bidid ? props?.Bidid : null,
      shippingrates,
      shippingrateid
    )
      .then((resp) => {
        if (resp.data.success) {
          setLoading(false);
          navigate("/order");
        } else {
          setLoading(false);
          toast.error(resp.data.message);
        }
      })
      .catch((err) => {
        console.log(err, "CreateSecondHandOrder12");
      });
  };

  //For the Buy products API's
  //userId used for the userId

  const handleUserAsk = (userid) => {
    if (!userid) {
      console.warn("User ID is missing. Aborting operation.");
      return;
    }

    if (props.error) {
      toast.error(
        "Shipping Service not available Please Contact to Support Service11"
      );
    } else if (updateBidAmount) {
      // This value is expected from location.state, but it is not being set anywhere,
      // so this condition is never met.
      ExportApi.handleUpdateBid(
        location?.state?.bidId,
        userid,
        JSON.parse(value),
        JSON.parse(sales),
        JSON.parse(processing),
        total
      )
        .then((resp) => {
          if (resp.data.message == "Bid updated successfully") {
            window.dispatchEvent(new Event("List"));
            toast.success("Bid updated successfully");
            setLoading(false);
            setFullPageLoader(false);
            setvalue(0);
            setUpdateBidAmount(0);
            navigate("/buySellManagment/buying");
          } else {
            setFullPageLoader(false);
            toast.error("Bid is not created! Something Went Wrong");
          }
        })
        .catch((err) => console.log(err));
    } else {
      ExportApi.getSingleUserData(userid).then((resp) => {
        let data = resp?.data?.data;

        if (data?.shipping_address?.street != null) {
          
          ExportApi.getCardData(userid)
            .then((response) => {
              let data = response.data.data;

              setCarddetails(data)
              setCardBrand(data.brand);
              setCardExpiry(data.lastFour);
              setFullPageLoader(false);
              if (data.brand) {
                if (prams.buy != undefined) {
                  if (props.type == 1) {
                    handleCreateOrder(props?.productId, userid);
                  } else {
                    const currentDate = new Date();
                    const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11, so add 1
                    const currentYear = currentDate.getFullYear();


                    if (currentYear > data.exp_year || (currentYear === data.exp_year && currentMonth > data.exp_month)) {
                      toast.error("Your card is expired. Please update your card.");
                      setLoading(false);
                      return
                    } else {
                      handleCreateSecondHandOrder(props?.productId, userid, value);
                      setFullPageLoader(false);
                    }
                  }
                } else {
                  if (buyNowStatus) {
                    if (props.type == 1) {
                      handleCreateOrder(props?.productId, userid);
                      // navigate("/order");
                    } else {
                      const currentDate = new Date();
                      const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11, so add 1
                      const currentYear = currentDate.getFullYear();


                      if (currentYear > data.exp_year || (currentYear === data.exp_year && currentMonth > data.exp_month)) {
                        toast.error("Your card is expired. Please update your card.");
                        setLoading(false);
                        return
                      } else {
                        handleCreateSecondHandOrder(props?.productId, userid, value);
                        setFullPageLoader(false);
                      }
                    }
                  } else {
                    setLoading(true);
                    let expiration = new Date();

                    ExportApi.Bid(
                      props?.productId,
                      userid,
                      value, // bid amount
                      addReturn ? (parseFloat(subtotal) + parseFloat(returnFee)).toFixed(2) : (parseFloat(subtotal)).toFixed(2), // total 
                      processing,
                      sales,
                      shippingrates,
                      shippingrateid,
                      bidExp,
                      testingFee,
                      parseFloat(returnFee),
                      addReturn
                    )
                      .then((resp) => {
                        if (resp.data.success) {
                          window.dispatchEvent(new Event("List"));
                          toast.success("Bid created successfully");
                          setLoading(false);
                          setFullPageLoader(false);
                        } else {
                          if (resp.data.message == "Please add card first") {
                            setShowCardModel(true);
                            setFullPageLoader(false);
                            setLoading(false);
                          } else {
                            // toast.error("Bid is not created");
                            toast.error(resp?.data?.message);
                            setFullPageLoader(false);
                            setLoading(false);
                          }
                        }
                      })
                      .catch((err) => console.log(err));
                  }
                }
              } else {
                if (localStorage.getItem("tokenuser")) {
                  toast.error("Add payment information to place an order");
                } else if (localStorage.getItem("admin")) {
                  toast.error("Please setup your payment detail");
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toast.error("Please complete User information");
        }
      });
    }
  };

  // for the Back Button
  const handleback = () => {
    if (
      prams.buy == "buy4" ||
      prams.buy == "buy2" ||
      prams.buy == "buy3" ||
      prams.buy == "buy"
    ) {
      setShow(true);
      navigate(-1);
    } else {
      setShow(true);
    }
  };


  // when the  bid value is changed by the user
  const handlePlaceBidValue = (bidvalue) => {
    setUpdating(true);

    // setting the raw value 
    const value = parseFloat(bidvalue);
    setvalue(value);

    // setting the processing fee
    let processingValue = (value / 100) * 3;
    setProcessing(processingValue.toFixed(2));

    // setting the testing fee
    let testingFee = bidvalue === 0 || bidvalue === "" || props?.type == 2 ? 0 : 25;

    // setting the total 
    let totalNumber =
      Number(value) +
      Number(testingFee) +
      Number(shippingrates) +
      Number(processingValue) +
      Number(sales);

    setTotal(totalNumber.toFixed(2));
    setInput(false);

    if (Number(bidvalue) <= props.Bid) {
      setShow(true);
      setBidStatus(false);
    } else {
      setBidStatus(true);
    }
  };

  //get the bid list
  const HandleBid = () => {
    if (localStorage.getItem("tokenuser")) {
      ExportApi.getBidList(JSON.parse(localStorage.getItem("tokenuser")).id)
        .then((resp) => {
          let data = resp.data.data;
          let result = [];
          for (let index = 0; index < resp.data.data?.length; index++) {
            let obj = {};
            const element = resp.data.data[index];
            obj = { ...element, ...element.productId };
            result.push(obj);
          }
          let data2 = result?.filter((item) => item.productId._id == props?.productId);
          if (data2.length > 0) {
            setBidAmount(data2[0].bidAmount);
          }
        })
        .catch((err) => console.log(err));
    } else {
    }
  };

  // for the back button in the Ask page
  const handleUserAsk1 = (show) => {
    if (prams.buy == "sell3" || prams.buy == "sell2" || prams.buy == "sell") {
      navigate(-1);
    } else {
      setUserAsk(show);
    }
  };

  //get the ask list
  const handleaskList = () => {
    if (localStorage.getItem("tokenuser")) {
      ExportApi.askList(loggedInUser?.id)
        .then((resp) => {

          let result = [];
          for (let index = 0; index < resp.data.data?.length; index++) {
            let obj = {};
            const element = resp.data.data[index];
            obj = { ...element, ...element.productId };
            result.push(obj);
          }

          let data2 = result?.filter((item) => item.productId._id == props?.productId);
          let data3 = data2?.filter((item) => item.askStatus == true);

          if (data2.length > 0) {
            if (prams.buy == "buy" && !props?.finalPriceBuy) {
              // when there is buy now page but no lowest ask available 

              // setting the processig fee 
              let processingValue = (data3[0].askAmount / 100) * 3;
              let shippingCost = Number(0.5 / 100) * data3[0].askAmount;
              let fee = shippingCost;
              let sf = Number(props.shippingFee);
              // let shipping = (fee + sf)?.toFixed(2);

              let shipping = value == "" || value == 0 ? 0 : shippingrates;

              let total =
                Number(data3[0].askAmount) +
                (data3[0].askAmount / 100) * 3 +
                (data3[0].askAmount / 100) * tax +
                shippingValue;
              let finalTotal = (total + Number(shipping))?.toFixed(2);

              setvalue(data3[0].askAmount);
              // setSales(salesValue.toFixed(2));
              setProcessing(processingValue.toFixed(2));
              setShippingFee(shipping);
              setTotal(finalTotal);
            } else if (prams.buy !== "buy" && updateBidAmount && !updating) {
              // setAskAmount(data3[0].askAmount);
              // direct buy now redirect
              let salesValue = (updateBidAmount / 100) * tax;
              let processingValue = (updateBidAmount / 100) * 3;
              let shippingCost = Number(0.5 / 100) * updateBidAmount;
              let fee = shippingCost;
              let sf = Number(props.shippingFee);
              // let shipping = (fee + sf)?.toFixed(2);

              let shipping = value == "" || value == 0 ? 0 : shippingrates;

              let total =
                Number(updateBidAmount) +
                (updateBidAmount / 100) * 3 +
                (updateBidAmount / 100) * tax +
                shippingValue;

              let finalTotal = (total + Number(shipping))?.toFixed(2);

              setvalue(updateBidAmount);
              // setSales(salesValue.toFixed(2));
              setProcessing(processingValue.toFixed(2));

              setShippingFee(shipping);
              setTotal(finalTotal);
            }

            // setShow(false);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  //get the card Data
  const handleCardData = (id) => {
    ExportApi.getCardData(id)
      .then((resp) => {
        let data = resp.data.data;
        setPaymentbtn(data);

        setCardBrand(data?.brand);
        setCardExpiry(data?.lastFour);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const redirectToAnotherPage = (id) => {
    navigate(`/profile/${id}`);
  };
  //start validation for the checkbox
  const handleFinalCheck = (value) => {
    if (value) {
      setFinalchecks(true);
      setNoCancelError(false);
    } else {
      setFinalchecks(false);
      setNoCancelError(true);
    }
  };
  const handleFinalCheck1 = (value) => {
    if (value) {
      setFinalchecks1(true);
      setAcceptedError(false);
    } else {
      setFinalchecks1(false);
      setAcceptedError(true);
    }
    // Auto-save is handled by useEffect hook
  };

  // const handleFinalCheck2 = (value) => {
  //   if (value) {
  //     setFinalchecks2(true);
  //     setFinalchecks1Error1(false);
  //   } else {
  //     setFinalchecks2(false);
  //     setFinalchecks1Error1(true);
  //   }
  // };

  // Save selections to localStorage
  const saveSelectionsToStorage = (shouldRemember = rememberSelections) => {
    // Only save if rememberSelections is true
    if (!shouldRemember) {
      return;
    }
    
    // Get current page URL (pathname + search params)
    const currentUrl = window.location.pathname + window.location.search;
    const storageKey = getStorageKey();
    
    const selections = {
      version: SELECTIONS_VERSION,
      url: currentUrl,
      addReturn: addReturn,
      noThanks: noThanks,
      noCancel: Finalchecks,
      accepted: Finalchecks1,
      rememberSelections: shouldRemember,
      timestamp: Date.now()
    };
    localStorage.setItem(storageKey, JSON.stringify(selections));
  };

  // Load selections from localStorage
  const loadSelectionsFromStorage = () => {
    try {
      const storageKey = getStorageKey();
      const stored = localStorage.getItem(storageKey);
      if (!stored) return false;

      const selections = JSON.parse(stored);
      
      // Check if version matches (if version changes, don't restore)
      if (selections.version !== SELECTIONS_VERSION) {
        localStorage.removeItem(storageKey);
        return false;
      }

      // Restore selections (works on any page, not just the same URL)
      // Restore addReturn and noThanks based on new field names or fallback to old field name
      if (selections.addReturn !== undefined) {
        setAddReturn(selections.addReturn);
      }
      if (selections.noThanks !== undefined) {
        setNoThanks(selections.noThanks);
      }
      // Fallback to old field name for backward compatibility
      if (selections.addReturnFee !== undefined && selections.addReturnFee !== null) {
        if (selections.addReturnFee === true) {
          setAddReturn(true);
          setNoThanks(false);
        } else {
          setAddReturn(false);
          setNoThanks(true);
        }
      }
      
      // Restore Finalchecks (noCancel)
      if (selections.noCancel !== undefined) {
        setFinalchecks(selections.noCancel);
        if (selections.noCancel) {
          setNoCancelError(false);
        }
      } else if (selections.Finalchecks !== undefined) {
        // Fallback to old field name for backward compatibility
        setFinalchecks(selections.Finalchecks);
        if (selections.Finalchecks) {
          setNoCancelError(false);
        }
      }
      
      // Restore Finalchecks1 (accepted)
      if (selections.accepted !== undefined) {
        setFinalchecks1(selections.accepted);
        if (selections.accepted) {
          setAcceptedError(false);
        }
      } else if (selections.Finalchecks1 !== undefined) {
        // Fallback to old field name for backward compatibility
        setFinalchecks1(selections.Finalchecks1);
        if (selections.Finalchecks1) {
          setAcceptedError(false);
        }
      }
      
      if (selections.rememberSelections !== undefined) {
        setRememberSelections(selections.rememberSelections);
      }

      return true;
    } catch (error) {
      console.error("Error loading selections from storage:", error);
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
      return false;
    }
  };

  // Handle remember selections checkbox
  const handleRememberSelections = (checked) => {
    setRememberSelections(checked);
    
    if (checked) {
      // Save current selections when checkbox is checked
      // Pass the new checked value directly to ensure correct state
      setTimeout(() => saveSelectionsToStorage(checked), 0);
    } else {
      // Remove stored selections when unchecked (for current URL only)
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
    }
  };

  useEffect(() => {
    let id = loggedInUser?.id;
    ExportApi.getSingleUserData(id)
      .then((resp) => {
        const Data = resp?.data?.data;
        const userdata = {
          street: Data?.shipping_address?.street,
          city: Data?.shipping_address?.city,
          state: Data?.shipping_address?.state,
          country: Data?.shipping_address?.country,
          postal_code: Data?.shipping_address?.postal_code,
          phone: Data?.phone,
        };

        setUsershipaddress(userdata);
        setValidStreet(userdata.street);
         setStreet(userdata?.street);
        setValidCity(userdata.city);
        setValidState(userdata.state);
        setValidCountry(userdata.country);
        setValidPostalCode(userdata.postal_code);
        setMobileNumber(userdata.phone);
        setCity(userdata?.city);
        setState(userdata?.state);
        setCountry(userdata?.country);
        setPostalCode(userdata?.postal_code);
        const newdata = {
          street: Data.shipping_address.street,
          city: Data?.shipping_address?.city,
          country: Data?.shipping_address?.country,
          postal_code: Data?.shipping_address?.postal_code,
          state: Data?.shipping_address?.state,
          phone: Data?.phone,
        };
        setIntialdata(newdata);
      })
      .catch((err) => {
        console.log(err);
      });
  },[loggedInUser]);

  useEffect(() => {
    if (localStorage.getItem("tokenuser")) {
      setTax(7.25);
      let number = JSON.parse(localStorage.getItem("tokenuser")).phone;
      let numberString = number == null ? null : number?.toString();
      let maskedResponse = "";
      if (numberString == null) {
        maskedResponse = null;
      } else {
        maskedResponse = `(${numberString.slice(0, 3)})${numberString.slice(
          3,
          6
        )}-${numberString.slice(6)}`;
      }

      setMobileNumber(maskedResponse);
    } else if (localStorage.getItem("admin")) {
      setTax(0);
      let number = JSON.parse(localStorage.getItem("admin")).phone;
      let numberString = number == null ? null : number?.toString();
      let maskedResponse = "";
      if (numberString == null) {
        maskedResponse = null;
      } else {
        maskedResponse = `(${numberString.slice(0, 3)})${numberString.slice(
          3,
          6
        )}-${numberString.slice(6)}`;
      }

      setMobileNumber(maskedResponse);
    }
  }, [value, props]);

  // Function to mask mobile number
  const maskMobileNumber = (number) => {
    let numberString = number == null ? "" : number?.toString();
    if (numberString === "") return null;
  
    return `(${numberString.slice(0, 3)})${numberString.slice(3, 6)}-${numberString.slice(6)}`;
  };
const fetchAndSetUserData = async () => {
  try {
    // Get user ID from localStorage, check if it's tokenuser or admin
    const user = loggedInUser
    if (!user) {
      console.error("No user found in localStorage.");
      return;
    }

    const { id, phone } = user;
    
    // Fetch user data using the API
    const resp = await ExportApi.getSingleUserData(id);
    let Data = resp?.data?.data;

    // Update state variables with the fetched data
    setStreet(Data?.shipping_address?.street);
    setValidStreet(Data?.shipping_address?.street);
    setCity(Data?.shipping_address?.city);
    setValidCity(Data?.shipping_address?.city);
    setState(Data?.shipping_address?.state);
    setValidState(Data?.shipping_address?.state);
    setCountry(Data?.shipping_address?.country);
    setValidCountry(Data?.shipping_address?.country);
    setPostalCode(Data?.shipping_address?.postal_code);
    setValidPostalCode(Data?.shipping_address?.postal_code);
    setPayoutLink(Data?.accountLink);

    // Set mobile number (masking logic)
    const maskedNumber = maskMobileNumber(phone);
    setMobileNumber(maskedNumber);

    // Fetch additional card data
    handleCardData(id);
    
  } catch (err) {
    console.log("Error fetching user data:", err);
  }
};

  useEffect(() => {
    handleaskList();
    HandleBid();
    if (loggedInUser) {
      handleCardData(loggedInUser?.id)
    }
  }, [loggedInUser]);

  useEffect(() => {
    if (prams.buy && prams.buy == "buy" && (!props.finalPriceBuy || props.finalPriceBuy == 0)) {
      navigate("/bidask/" + prams.slug);
      setShow(true);
    }
  }, [props.finalPriceBuy])

  useEffect(() => {
    // this works when we are on the buy now page and lowest ask is available
    if (prams.buy == "buy" && props.finalPriceBuy) {
      // setting the value 
      setvalue(props.finalPriceBuy);

      // setting the processing fee
      let processingValue = (props.finalPriceBuy / 100) * 3;
      setProcessing(processingValue.toFixed(2));

      // setting the testing fee 
      let testingFee = !props?.finalPriceBuy || props?.finalPriceBuy === 0 || props?.finalPriceBuy === "" || props?.type == 2 ? 0 : 25;

      let total =
        Number(props.finalPriceBuy) +
        Number(testingFee) +
        Number(shippingrates) +
        Number(processingValue) +
        Number(sales);

      setTotal(total);
      setShow(false);
    }
  }, [props, props?.prams , shippingrates , sales]);

  useEffect(() => {
    if (props?.Bid) {
      let salesValue = (props?.Bid / 100) * tax;
      let processingValue = (props?.Bid / 100) * 3;

      let total =
        Number(props?.Bid) +
        (props?.Bid / 100) * 3 +
        (props?.Bid / 100) * tax +
        10;
      let finalTotal = total + 10;

      setProcessing(processingValue.toFixed(2));
      setTotal(finalTotal);
    }
  }, [props?.Bid]);

  useEffect(() => {
    if (popup) {
      const timer = setTimeout(() => {
        setPopup(false);
        if (localStorage.getItem("tokenuser")) {
          redirectToAnotherPage(
            JSON.parse(localStorage.getItem("tokenuser")).id
          );
        } else if (localStorage.getItem("admin")) {
          redirectToAnotherPage(JSON.parse(localStorage.getItem("admin")).id);
        } else {
        }
      }, 2000); // Specify the duration in milliseconds (2 seconds in this example)

      return () => clearTimeout(timer);
    }
  }, [popup]);

  const [bidExp, setBidExp] = useState("30");
  const bidExpiration = (e) => {
    setBidExp(e.target.value);
  };

  const handlePaymentEditClicknew = (key = undefined) => {
    if (key !== undefined) {
      localStorage.setItem("activeTab", key);
    }
    if (localStorage.getItem("tokenuser") || localStorage.getItem("admin")) {
      let userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;
      setPrimaryAccountModel(true);
    } else {
      setShowModal(true);
      setPrimaryAccountModel(false);
    }
  };

  const handleShippingAddressEditClick = () => {
    if (loggedInUser) {
      setShowAddressModal(true);
    } else {
      setShowModal(true);
      setShowAddressModal(false);
    }
  };

  // Function to handle the "Back" button click in the review step
  const handleReviewAsk = () => {
    if (!loggedInUser) {
      setShowModal(true);
    } else if (cardBrand && cardExpiry && street && bidExp) {
      setShow(false);
    } else {
      toast.error("Please Fill all User Information");
    }
  };
  
  const handleUpdateAddress = () => {
    setButtonAddressLoader(true);
 

let currentState = validState;
if (!currentState && stateRef.current) {
  currentState = stateRef.current.value;
  setValidState(currentState); // sync with state
}

 const validateField = (value, fieldName) => {
  if (!value?.trim()) {
    toast.error(`${fieldName} is required`);
    return false;
  }
  return true;
};

// Use this inside your `handleUpdateAddress`:
if (
  !validateField(validStreet, "Street address") ||
  !validateField(validCity, "City") ||
  !validateField(currentState, "State")
) {
  setButtonAddressLoader(false);
  return;
}

    if (!mobileNumber) {
      toast.error("Phone Number is Required");
      setButtonAddressLoader(false);
      return;
    }

    const newPhoneNumber = mobileNumber.toString().replace(/\D/g, "");  

    const postalCodeRegex = /^\d{5}(-\d{4})?$/;

    if (!postalCodeRegex.test(validPostalCode)) {
      toast.error(
        'Postal Code must be 5 digits or in the format "12345" or "12345-6789"'
      );
      setButtonAddressLoader(false);
      return;
    }

    // Construct the new address object
    const newAddress = {
      street: validStreet,
      city: validCity,
      state: currentState,
      country: validcountry,
      postal_code: validPostalCode,
      phone: newPhoneNumber,
    };

    // Check if the new address is the same as the current address
    if (
      intialdata.street == validStreet &&
      intialdata.city == validCity &&
      intialdata.state == currentState &&
      intialdata.postal_code == validPostalCode &&
      intialdata.phone == newPhoneNumber
    ) {
      toast.error("Address is the same as the current address");
      setButtonAddressLoader(false);
      return;
    }

    // Proceed with updating the address if it has changed
    let id;
    if (localStorage.getItem("tokenuser")) {
      id = JSON.parse(localStorage.getItem("tokenuser"))?.id;
    } else {
      id = JSON.parse(localStorage.getItem("admin"))?.id;
    }

    ExportApi.updateSingleUserData(
      id,
      validStreet,
      validCity,
      currentState,
      validcountry,
      validPostalCode,
      newPhoneNumber
    )
      .then((resp) => {
          if (resp?.data.status == true){
        let Data = resp?.data?.result;
        setPostalCode(Data?.shipping_address?.postal_code);
        setCountry(Data?.shipping_address?.country);
        setState(Data?.shipping_address?.state);
        setCity(Data?.shipping_address?.city);
        setStreet(Data?.shipping_address?.street);
        localStorage.setItem("useraddress", JSON.stringify(validStreet));
        toast.success("Address Updated Successfully");
        setShowAddressModal(false);
        setButtonAddressLoader(false);
        const newdata = {
          street: Data.shipping_address.street,
          city: Data?.shipping_address?.city,
          country: Data?.shipping_address?.country,
          postal_code: Data?.shipping_address?.postal_code,
          state: Data?.shipping_address?.state,
          phone: Data?.phone,
        };
        setIntialdata(newdata);
        setTimeout(() => {
          window.location.reload();
        }, 2000);

        var localData = localStorage.getItem("tokenuser");
        var parsedData = JSON.parse(localData);
        parsedData.phone = Data?.phone;
        localStorage.setItem("tokenuser", JSON.stringify(parsedData));
        setUsershipaddress(newAddress); // Update state to trigger useEffect
      }else{
         const errorDetails = resp?.data?.details?.[0]?.text || "Failed to update address";
         toast.error(errorDetails);  // 👈 shows message like: "Unable to validate street address line..."
           setButtonAddressLoader(false);

      }
      })
      .catch((err) => {
        setButtonAddressLoader(false);
        console.log(err);
      });
  };

  const valueToAdd = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
  const shippingFeeToAdd = isNaN(parseFloat(shippingrates)) || isLoggedInUserAdmin
    ? 0
    : parseFloat(shippingrates);
  const salesToAdd = isNaN(parseFloat(sales)) || isLoggedInUserAdmin ? 0 : parseFloat(sales);
  const processingToAdd = isNaN(parseFloat(processing)) || isLoggedInUserAdmin
    ? 0
    : parseFloat(processing);

    const returnFeeToAdd = isNaN(parseFloat(returnFee)) || isLoggedInUserAdmin
    ? 0
    : parseFloat(returnFee)

  // Calculate subtotal
  const testingFee = props?.type == 2 || isLoggedInUserAdmin ? 0 : 25;
  const subtotal =
    valueToAdd + testingFee + parseFloat(shippingFeeToAdd) + salesToAdd + processingToAdd;

const isAdmin = loggedInUser && loggedInUser?.role == "admin" ? true : false;
  return (
    <>
      {fullPageLoader ? (
        <div className="loader-icon" style={{ marginBlock: "80px" }}>
          <i className="fa-solid fa-spinner fa-spin-pulse"></i>
        </div>
      ) : (
        <Tabs
          // onSelect={handleTabChange}
          defaultActiveKey= {activeKey}
          id="uncontrolled-tab-example"
          className="mb-3"
          hidden={
            prams.buy == "buy" ||
            prams.buy == "buy2" ||
            prams.buy == "buy3" ||
            prams.buy == "buy4" ||
            prams.buy == "sell2" ||
            prams.buy == "sell3" ||
            prams.buy == "sell" ||
            Show == false
          }
        >
          <Tab eventKey="home" title="Place Ask">
            <Sonnet
              Show={Show}
              update={setShow}
              Askid={props?.Askid}
              Data={props?.Ask}
              Data2={props?.Bid}
              Data3={props?.secondBid}
              Data4={askAmount}
              Data5={props?.usedBid}
              Type={props?.type}
              Data7={props?.website}
              handleUserAsk1={handleUserAsk1}
              shipping={props?.shippingFee}
              cardExpiry={cardExpiry}
              cardBrand={cardBrand}
              error={props?.error}
              FinalPriceSell1={
                props?.FinalPriceSell ? props?.FinalPriceSell : 0
              }
              paymentbtn={paymentbtn}
              handlePaymentEditClicknew={handlePaymentEditClicknew}
              productId={props.productId}
              handleSearch={props.handleSearch}
              handleBid={props.handleBid}
              handleAsk={props.handleAsk}
            />
          </Tab>
          <Tab
            eventKey="profile"

            title="Place Bid"
            className="place-bid-active"
          >
            <div>
              {Show ? (
                <>
                  {props?.Bid ? (
                    <p className="d-flex justify-content-end">
                      Highest Bid: ${props?.Bid}
                    </p>
                  ) : (
                    ""
                  )}

                  {props?.Bid && props?.Bid != 0 && (
                    <div className="d-flex flex-row gap-1 align-items-center">
                    <p className="m-0 px-0" style={{ fontSize: "15px" }}>
                        {`To be first in line  ->`}
                      </p>
                      <span className="px-3 py-1" onClick={() => handlePlaceBidValue(props.Bid + 1)} style={{ fontSize: "12px" , cursor : "pointer" , backgroundColor : "#D7D5D5" , borderRadius : "8px"}}>
                        Offer ${props.Bid + 1}
                      </span>
                    </div>
                  )
                  }
                  <div className="d-flex border rounded p-2">
                    <div className="quantity-custom">
                      <InputGroup className="mb-3">
                        <InputGroup.Text
                          id="basic-addon1"
                          className="bg-none border-end-0 text-dark"
                        >
                          $
                        </InputGroup.Text>
                      
                          <Form.Control
                            value={value === 0 ? "" : value}
                            onChange={(e) => {
                              const newValue = e.target.value;

                              // Prevent negative values
                              if (newValue === "") {
                              setBidValue("");
                              setvalue("");
                            } else if (parseFloat(newValue) >= 0) {
                              setBidValue(newValue);
                              setvalue(newValue);
                            }
                            // Else, do nothing (negative number entered)
                          }}
                          placeholder="Enter Bid"
                          type="number"
                          className="border-start-0"
                          aria-label="number"
                          aria-describedby="basic-addon1"
                        />
           
                      </InputGroup>
                    </div>

                    <div className="ms-auto customsell-btn">
                      {props.Ask ? (
                        <Button
                          className="sell-btn border-0 buy-button ms-2"
                          style={{ backgroundColor: "rgb(34, 94, 64)" ,   fontWeight : 650 }}
                          onClick={() => {
                            if(!loggedInUser){
                               setShowModal(true);
                               setSignup(true);
                               setForgot(false);
                            }else{
                              navigate("/bidask/" + props?.productSlug + "/buy")
                            }
                          }}
                        >
                          Buy Now for ${props.Ask}
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {localStorage.getItem("tokenuser") ? (
                    value > 0 ? (
                      props?.Bid <= value ? (
                        <h2 className="text-capitalize text-center fs-4 my-4">
                          you are the highest bid!
                        </h2>
                      ) : props?.Bid > value ? (
                        <h2 className="text-capitalize text-center fs-4 my-4">
                          you are not the highest bid!
                        </h2>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )
                  ) : value > 0 ? (
                    props?.Bid <= value ? (
                      <h2 className="text-capitalize text-center fs-4 my-4">
                        you are the highest bid!
                      </h2>
                    ) : props?.Bid > value ? (
                      <h2 className="text-capitalize text-center fs-4 my-4">
                        you are not the highest bid!
                      </h2>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}

                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p className="mb-0">Your Bid</p>
                    <p className="ms-auto mb-0 truncated-number">
                          {value > 0 ? `$${value}` : "—"}
                    </p>
                  </div>
                  {props?.type == 2 ? (
                    ""
                    ) : (
                      <div className="d-flex align-items-center border-bottom pb-2 mb-3">
                        <p className="mb-0">Testing Fees</p>
                        <ReactTooltip
                          className="custom-tooltip text-center"
                          anchorId={`app-batch-spread-tab`}
                          place="bottom"
                          clickable={true}
                          closeOnScroll={false}
                          content={
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  "<p>Every used graphic card is tested and benchmarked to verify it meets our quality standards.</p>",
                              }}
                            />
                          }
                        />
                        <span id={`app-batch-spread-tab`}>
                          <QuestionMarkSvg />
                        </span>

                        {localStorage.getItem("admin") ? (
                          <p className="ms-auto mb-0">$0</p>
                        ) : props.type === 2 ? (
                          <p className="ms-auto mb-0">$0</p>
                        ) : value > 0 ? (
                          <p className="ms-auto mb-0">$25.00</p>
                        ) : props.Bid ? (
                          <p className="ms-auto mb-0">—</p>
                        ) : (
                          <p className="ms-auto mb-0">—</p>
                        )}
                      </div>
                    )}

                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p className="mb-0">{`Shipping ${estimatedShippingRate ? "(est)" : ""}`}</p>
                    {
                      isLoggedInUserAdmin ? (
                        <p className="ms-auto mb-0">$0</p>
                      ) : value > 0 && shiploader ? (
                        <p className="ms-auto mb-0">Loading...</p>
                      ) : value > 0 && !shiploader && !isNaN(shippingrates) ? (
                        <p className="ms-auto mb-0">${shippingrates?.toFixed(2)}</p>
                      ) : (
                         <p className="ms-auto mb-0">—</p>
                      )
                    }
                    </div>

                    <div className="d-flex flex-column align-items-center  border-bottom pb-2 mb-3">
                      <div
                        className="d-flex  align-items-center w-100"
                        onClick={toggleTaxesDetails}
                        style={{ cursor: "pointer" }}
                      >
                        <p className="mb-0 text-capitalize">
                          Taxes & Other
                        </p>
                        <DownArrow />

                        {
                          loggedInUser && isLoggedInUserAdmin && value > 0 ? (
                            <p className="ms-auto mb-0">$0</p>
                          ) : value > 0 ? (
                            <p className="ms-auto mb-0">{`$${(Number(processing) + Number(sales)).toFixed(2)}`}</p>
                          ) : (
                            <p className="ms-auto mb-0">—</p>
                          )
                        }

                      </div>

                      {showTaxesDetails && (
                        <div className="taxes-details w-100 ps-5 mt-3">
                          <div className="d-flex align-items-center pb-2 mb-0">
                            <p className="mb-0 text-capitalize">Sales Tax</p>
                            {
                              isLoggedInUserAdmin ? (
                                <p className="ms-auto mb-0">$0</p>
                              ) : value > 0 && salesTaxLoader ? (
                                <p className="ms-auto mb-0">Loading...</p>
                              ) : value > 0 && !salesTaxLoader && !isNaN(Number(sales)) ? (
                                <p className="ms-auto mb-0">${Number(sales).toFixed(2)}</p>
                              ) : (
                                <p className="ms-auto mb-0">—</p>
                              )
                            }
                          </div>
                          <div className="d-flex align-items-center pb-2 mb-0">
                            <p className="mb-0 text-capitalize">
                              Processing Fee &nbsp;
                              <ReactTooltip
                                anchorId="processing-bid"
                                place="bottom"
                                clickable={true}
                                closeOnScroll={false}
                                content="The cost associated with processing the order"
                              />
                              <span id={`processing-bid`}>
                                <QuestionMarkSvg />
                              </span>
                            </p>
                            {
                              loggedInUser && isLoggedInUserAdmin && value > 0 ? (
                                <p className="ms-auto mb-0">$0</p>
                              ) : loggedInUser && isLoggedInUserAdmin && value <= 0 ? (
                                <p className="ms-auto mb-0">—</p>
                              ) : value > 0 && !isNaN(Number(processing)) ? (
                                <p className="ms-auto mb-0">${Number(processing).toFixed(2)}</p>
                              ) : (
                                <p className="ms-auto mb-0">—</p>
                              )
                            }
                          </div>


                        </div>
                      )}
                    </div>

                    <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                      <p style={{fontWeight : 600}} className="mb-0">Total {estimatedShippingRate ? "(est)" : ""}</p>
                      {
                        shiploader && value > 0 ? (
                          <p className="ms-auto mb-0">Loading...</p>
                        ) : value > 0 && !shiploader ? (
                          <p className="ms-auto mb-0"> {`$${subtotal.toFixed(2)}`}</p>
                        ) : (
                          <p className="ms-auto mb-0">—</p>
                        )
                      }
                    </div>
                    
                    {
                      estimatedShippingRate && (
                        <p style={{fontWeight : 600, fontSize : "clamp(1rem, 1.4vw, 1rem)"}}>
                          Final Payment and Shipping confirmed after address
                        </p>
                      )
                    }

                    {
                      loggedInUser ? (
                        <div class="border rounded p-2 ask-main">
                          <div class="ask-expiration d-flex">
                            <p class="mb-0">
                              <ClockSvg />
                              Bid Expiration
                            </p>
                            <div class="ms-auto">
                              <select
                                class="border py-1 px-2"
                                onChange={(e) => bidExpiration(e)}
                              >

                                <option value="3">3 days</option>
                                <option value="7">7 days</option>
                                <option value="14">14 days</option>
                                <option selected value="30">
                                  30 days
                                </option>
                                <option value="60">60 days</option>
                              </select>
                            </div>
                          </div>
                          <div className="payment-status">
                            <div class="ask-expiration d-flex mt-3">
                              <p class="mb-0  d-flex align-items-center">
                                <WalletSvg />
                                <span>Payment method </span>&nbsp; : &nbsp;{" "}
                                {cardBrand && cardExpiry ? (
                                  cardBrand + cardExpiry
                                ) : (
                                  <span className="error-messages">Required</span>
                                )}
                              </p>

                              {!paymentbtn ? (
                                <>
                                  <div class="ms-auto">
                                    <button
                                      type="button"
                                      class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                      onClick={() => {
                                        if (!localStorage.getItem("tokenuser")) {
                                          setShowModal(true);
                                        } else {
                                          setPrimaryAccountModel(true);
                                        }
                                      }}
                                    >
                                      {" "}
                                      {!localStorage.getItem("tokenuser") ? (
                                        <>edit</>
                                      ) : (
                                        <>add</>
                                      )}
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div class="ms-auto">
                                    <button
                                      type="button"
                                      class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                      onClick={() => handlePaymentEditClicknew()}
                                    >
                                      edit
                                    </button>
                                  </div>
                                </>
                              )}

                            </div>

                            <div className="ask-expiration d-flex mt-3">
                              <p className="mb-0 d-flex align-items-start me-2">
                                <WalletSvg />
                                Shipping Address : &nbsp;{" "}
                                {street ? (
                                  <div className="d-flex align-items-start flex-column ms-2">
                                    <p className="mb-0">{street}</p>
                                    <p className="mb-0">{city}</p>
                                    <p className="mb-0">{postalCode}</p>
                                  </div>
                                ) : (
                                  <span className="error-messages">Required</span>
                                )}
                              </p>
                              <div class="ms-auto">
                                <button
                                  type="button"
                                  class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                  onClick={handleShippingAddressEditClick}
                                >
                                  edit
                                </button>

                              </div>
                            </div>
                          </div>
                        </div>
                      )
                        :
                        (
                          <div class="border rounded p-2 ask-main">
                            <div class="ask-expiration d-flex flex-column justify-content-start">
                              <h5 style={{
                                fontWeight : 700
                              }}>
                                Sign up to buy or sell
                              </h5>
                              <p style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }} class="mb-0">
                                Required to place bids/asks and complete checkout
                              </p>
                            </div>
                          </div>
                        )
                    }
                  </>
              ) : (
                <div className="review-part">
                  {prams.buy != undefined ? (
                    <h2 className="text-capitalize text-center fs-4 mt-4 mb-2">
                      Buy Now
                    </h2>
                  ) : (
                    <h2 className="text-capitalize text-center fs-4 mt-4 mb-2">
                      Place Bid
                    </h2>
                  )}
                  <p className="text-center">
                    Please confirm your Purchase details below
                  </p>
                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    {prams.buy != undefined ? (
                      <p className="mb-0 text-capitalize">Purchase price</p>
                    ) : (
                      <p className="mb-0 text-capitalize">Your Bid</p>
                    )}
                    <p className="ms-auto mb-0 truncated-number">
                      {isNaN(value) ? "—" : "$" + value?.toFixed(2)}
                    </p>
                  </div>
                  {props?.type == 2 ? (
                    ""
                  ) : (
                    <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                        <p className="mb-0">Testing Fees</p>
                        <ReactTooltip
                          className="custom-tooltip text-center"
                          anchorId={`app-batch-spread-tab`}
                          place="bottom"
                          clickable={true}
                          closeOnScroll={false}
                          content={
                            <div
                            dangerouslySetInnerHTML={{
                              __html:
                                "<p>Every used graphic card is tested and benchmarked to verify it meets our quality standards.</p>",
                            }}
                          />
                          }
                        />
                          <span id={`app-batch-spread-tab`}>
                          <QuestionMarkSvg />
                        </span>

                        {localStorage.getItem("admin") ? (
                          <p className="ms-auto mb-0">$0</p>
                        ) : (
                          <p className="ms-auto mb-0">
                            {/* $25.00 */}
                            {props?.type == 2 ? "$0" : "$25.00"}
                          </p>
                        )}
                      </div>
                  )}
                  
                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p className="mb-0 text-capitalize">shipping {estimatedShippingRate ? "(est)" : ""}</p>
                    {localStorage.getItem("admin") ? (
                      <p className="ms-auto mb-0">$0</p>
                    ) : (
                      <p className="ms-auto mb-0">
                        {shiploader ? "Loading..." : (isNaN(shippingrates) || shippingrates === undefined ? "—" : `$${shippingrates?.toFixed(2)}`)}
                      </p>
                    )}
                  </div>

                   

                  <div className="d-flex flex-column align-items-center  border-bottom pb-2 mb-3">
                    <div
                      className="d-flex  align-items-center w-100"
                      onClick={toggleTaxesDetails}
                      style={{ cursor: "pointer" }}
                    >
                      <p className="mb-0 text-capitalize">
                        Taxes & Other
                        {/* <FontAwesomeIcon icon={faCaretDown} style={{ color: "#000", width: "15px", height: "15px"}} /> */}
                      </p>
                     <DownArrow/>
                      {localStorage.getItem("admin") ? (
                        <p className="ms-auto mb-0">$0</p>
                      ) : (
                        <p className="ms-auto mb-0 truncated-number">
                          ${(Number(processing) + Number(sales)).toFixed(2)}
                        </p>
                      )}
                    </div>

                    {showTaxesDetails && (
                      <div className="taxes-details w-100 ps-5 mt-3">
                        <div className="d-flex align-items-center pb-2 mb-0">
                          <p className="mb-0 text-capitalize">Sales Tax</p>
                           {
                              isLoggedInUserAdmin ? (
                                <p className="ms-auto mb-0">$0</p>
                              ) : value > 0 && salesTaxLoader ? (
                                <p className="ms-auto mb-0">Loading...</p>
                              ) : value > 0 && !salesTaxLoader && !isNaN(Number(sales)) ? (
                                  <p className="ms-auto mb-0">${Number(sales).toFixed(2)}</p>
                                ) : (
                                  <p className="ms-auto mb-0">—</p>
                                )
                            }
                        </div>
                        <div className="d-flex align-items-center pb-2 mb-0">
                          <p className="mb-0 text-capitalize">
                            Processing Fee &nbsp;
                            <ReactTooltip
                              anchorId="processing-bid"
                              place="bottom"
                              clickable={true}
                              closeOnScroll={false}
                                  content="The cost associated with processing the order"
                                />
                                <span id={`processing-bid`}>
                                  <QuestionMarkSvg />
                                </span>
                          </p>
                          {localStorage.getItem("admin") ? (
                            <p className="ms-auto mb-0">$0</p>
                          ) : (
                            <p className="ms-auto mb-0 truncated-number">
                              ${processing}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  

                      {
                        addReturn && (
                          <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                            <p className="mb-0 text-capitalize">Return Shield Fee (8%)</p>
                            {
                              value > 0 && !isNaN(returnFee) ? (
                                <p className="ms-auto mb-0">${returnFee}</p>
                              ) : (
                                <p className="ms-auto mb-0">—</p>
                              )
                            }
                          </div>
                        )
                      }

                      <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                        <p style={{fontWeight : 600}} className="mb-0 text-capitalize">Total(incl. tax.) {estimatedShippingRate ? "(est)" : ""}</p>
                        
                        {isLoggedInUserAdmin ? (
                          <p className="ms-auto mb-0 fw-bold">
                            {isNaN(value) || value === undefined ? "—" : "$" + parseFloat(value).toFixed(2)}
                          </p>
                        ) : (
                          <p className={`ms-auto mb-0 ${!shiploader ? 'fw-bold' : ''} truncated-number`}>
                            {shiploader ? "Loading..." 
                            : isNaN(subtotal) || subtotal === undefined ? "—" 
                            : addReturn ? `$${(parseFloat(subtotal) + parseFloat(returnFee)).toFixed(2)}`
                            : `$${parseFloat(subtotal).toFixed(2)}`}
                          </p>
                        )}
                      </div>

                      {
                        loggedInUser ? (
                          <>

                            <div class="border rounded p-3 ask-main">
                              {prams.buy != undefined ? (
                                <></>
                              ) : (
                                <div class="ask-expiration d-flex">
                                  <p class="mb-0">
                                    <ClockSvg />
                                    Bid Expiration
                                  </p>
                                  <div class="ms-auto">

                                    {bidExp} Day
                                  </div>
                                </div>
                              )}
                              <div className="payment-status">
                                <div class="ask-expiration d-flex mt-3">
                                  <p class="mb-0 d-flex">
                                    <WalletSvg />
                                    Payment method :&nbsp;
                                    <p className="text-end">
                                      {cardBrand && cardExpiry ? (
                                        cardBrand + cardExpiry
                                      ) : (
                                        <span className="error-messages">Required</span>
                                      )}
                                    </p>
                                  </p>

                                  <div class="ms-auto d-flex">
                                    {prams.buy != undefined ? (
                                      <div class="ms-auto">
                                        <button
                                          type="button"
                                          class="text-uppercase ms-1 edit-btn bg-transparent border-0 btn btn-primary"
                                          onClick={() => handlePaymentEditClicknew()}
                                        >
                                          edit
                                        </button>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div class="ask-expiration  mt-3">
                                  <p class="mb-0 d-flex align-items-start ">
                                    <svg
                                      fill="currentColor"
                                      className="me-2 mt-1"
                                      height="19px"
                                      width="19px"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 487.4 487.4"
                                      enable-background="new 0 0 487.4 487.4"
                                    >
                                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <g>
                                          {" "}
                                          <path d="M381.6,144.1h-63.3V25.9H0v369.2h33.2c1.1,36.4,31.8,66.4,68.4,66.4s67.3-30,68.4-66.4h154.6c1.1,36.4,31.8,66.4,68.4,66.4 s67.3-30,68.4-66.4h26V251L381.6,144.1z M101.6,440.7c-25.9,0-47.7-21.8-47.7-47.7s21.8-47.7,47.7-47.7s47.7,21.8,47.7,47.7 S127.5,440.7,101.6,440.7z M297.6,374.4H167.4c-8.3-28.5-34.9-49.8-65.8-49.8s-57.5,21.3-65.8,49.8H20.7V46.6h276.9V374.4z M387.9,179.6l65.5,66.2h-65.5V179.6z M393,440.7c-25.9,0-47.7-21.8-47.7-47.7s21.8-47.7,47.7-47.7s47.7,21.8,47.7,47.7 S419,440.7,393,440.7z M466.7,374.4h-7.9l0,0c-8.3-28.5-34.9-49.8-65.8-49.8s-57.5,21.3-65.8,49.8h-7.9V164.9H367v101.6h99.7V374.4 z"></path>{" "}
                                        </g>{" "}
                                      </g>
                                    </svg>
                                    <p className="responsive-label">
                                      Return Shipping<span className="mobile-break"><br /></span>Address :
                                    </p>

                                    &nbsp;
                                    {street ? (
                                      <div className="d-flex  flex-column ">
                                        <p className="mb-0">{street}</p>
                                        <p className="mb-0">{city}</p>
                                        <p className="mb-0">{postalCode}</p>
                                      </div>
                                    ) : (
                                      <span className="error-messages">Required</span>
                                    )}
                                    <div class="ms-auto">
                                      {/* {street ? (
                            <>
                              {street}
                              {city}
                              {country + " " + postalCode}
                            </>
                          ) : (<span className="error-messages">Required</span>)} */}
                                      {prams.buy != undefined ? (
                                        <div class="ms-auto">
                                          <button
                                            type="button"
                                            class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                            onClick={handleShippingAddressEditClick}
                                          >
                                            edit
                                          </button>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="mt-2">
                              <p style={{ paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", fontStyle: "italic" }} className="px-4">
                                Most order ship in 1-3 business days after seller handover & testing some make take longer.
                                <a href={`${process.env.REACT_APP_REDIRECT_URI}/help/shipping-instructions`} className="ms-2" style={{ color: "#ff4400", textDecoration: "none" }}>
                                  Learn more →
                                </a>
                              </p>
                            </div>

                            <div className="shipping-options p-3 border mt-2" style={{ borderRadius: "10px" }}>

                              <span className="fw-semibold d-block mb-2">
                                Returns (Select one)
                              </span>

                              <div className="d-flex justify-content-start align-items-start">
                                <input
                                  type="radio"
                                  name="shipping"
                                  value="addFee"
                                  checked={addReturn}
                                  className="d-flex justify-content-start align-items-start mt-1"
                                  onChange={() => {
                                    setAddReturn(true);
                                    setNoThanks(false);
                                    setReturnFeeError(false);
                                    if (rememberSelections) {
                                      setTimeout(() => saveSelectionsToStorage(), 0);
                                    }
                                  }}
                                />
                                <div className="shipping-text ms-2">
                                  <span className="">
                                    <strong>Add Return Shield (8% fee) - </strong>
                                    Return for any reason within 7 days.
                                  </span>
                                  <p style={{ fontSize: "12px" }} className="mb-0">
                                    Return shield fee is non-refundable. Original S/H & testing fee non-refundable.
                                    Return label cost is deducted from the refund.
                                  </p>
                                </div>
                              </div>

                              <hr />

                              <div className="d-flex justify-content-start align-items-start">
                                <input
                                  type="radio"
                                  name="shipping"
                                  value="noFee"
                                  checked={noThanks}
                                  className="d-flex justify-content-start align-items-start mt-1"
                                  onChange={() => {
                                    setNoThanks(true);
                                    setAddReturn(false);
                                    setReturnFeeError(false);
                                    if (rememberSelections) {
                                      setTimeout(() => saveSelectionsToStorage(), 0);
                                    }
                                  }}
                                />


                                <div className="shipping-text ms-2">
                                  <span className="">
                                    <strong>No thanks - </strong>
                                    You are still covered by DOA protection (3-Day).
                                  </span>
                                  <p style={{ fontSize: "12px" }} className="mb-0">
                                    We cover return shipping full refund incl. S/H & fee if DOA is verified.
                                  </p>
                                </div>
                              </div>

                              <a href={`${process.env.REACT_APP_REDIRECT_URI}/help/returns`} className="mt-2 ms-1" style={{ color: "#ff4400", textDecoration: "none" }}>See details for more return policies →</a>
                              {returnFeeError && (
                                <p style={{ color: "red", fontSize: "16px", marginTop: "8px", marginBottom: "0" }}>
                                  Complete necessary checkboxes for seamless shopping
                                </p>
                              )}
                            </div>

                            <div className="pb-2 mt-3 mb-3 border rounded p-4" style={{ borderRadius: "10px" }}>
                              <h5 className="mb-4">Pre Purchase Verification</h5>
                              <p className="d-flex align-items-start mb-0 pb-2 mb-2">
                                <input
                                  className="me-2  mt-2"
                                  type="checkbox"
                                  checked={Finalchecks || false}
                                  onChange={(e) => {
                                    handleFinalCheck(e.target.checked);
                                    // Auto-save is handled by useEffect hook
                                  }}
                                />
                                I understand that once I Buy Now or my Bid is accepted, the order is final (no buyer cancellations).
                              </p>
                              <p style={{ color: "red", fontSize: "16px" }}>
                              </p>
                              <hr />

                              {/* <p className="d-flex align-items-start mb-0 pb-2 mb-2">
                      <input
                        className="me-2 mt-2"
                        type="checkbox"
                        onChange={(e) => {
                          handleFinalCheck1(e.target.checked);
                        }}
                      />
                      I understand this is a resale marketplace; OEM warranty is not guaranteed. Used (Tested) items are GPUwizVerified. New (Resale) items are factory-sealed. I agree to the 
                      <a href={`${process.env.REACT_APP_REDIRECT_URI}/terms`} className="ms-2" style={{color : "#ff4400" , textDecoration : "none"}}>Terms of Service</a> including the <a href={`${process.env.REACT_APP_REDIRECT_URI}/terms`} className="ms-2" style={{color : "#ff4400" , textDecoration : "none"}}>Return Policy</a>.
                    </p> */}

                              <p className="d-flex align-items-start mb-0 pb-2 mb-2">
                                <input
                                  className="me-2 mt-2"
                                  type="checkbox"
                                  checked={Finalchecks1 || false}
                                  onChange={(e) => {
                                    handleFinalCheck1(e.target.checked);
                                  }}
                                />
                                <span className="d-inline-block">
                                  I understand this is a resale marketplace; OEM warranty is not guaranteed. Used (Tested) items are GPUwizVerified. New (Resale) items are factory-sealed. I agree to the{" "}
                                  <a
                                    target="_blank"
                                    href={`${process.env.REACT_APP_REDIRECT_URI}/terms`}
                                    style={{ color: "#ff4400", textDecoration: "none" }}
                                  >
                                    Terms of Service
                                  </a>
                                  {" "}including the{" "}
                                  <a
                                    target="_blank"
                                    href={`${process.env.REACT_APP_REDIRECT_URI}/terms`}
                                    style={{ color: "#ff4400", textDecoration: "none" }}
                                  >
                                    Return Policy
                                  </a>.
                                </span>
                              </p>

                              <p style={{ color: "red", fontSize: "16px" }}>
                                {/* {!Finalchecks1Error ? "" : "Complete necessary checkboxes for seamless shopping"} */}
                              </p>
                              {/* <hr /> */}

                              {/* <p className="d-flex align-items-start mb-0 pb-2 mb-2">
                      <input
                        className="me-2  mt-2"
                        type="checkbox"
                        onChange={(e) => {
                          handleFinalCheck2(e.target.checked);
                        }}
                      />
                      I understand that shipping can take longer due to seller
                      performance and the inspection process.
                    </p> */}
                              <p style={{ color: "red", fontSize: "16px" }}>
                                {/* {!Finalchecks1Error1 ? "" : "Complete necessary checkboxes for seamless shopping"} */}
                              </p>



                            </div>

                            <p className="d-flex align-items-start mb-0 pb-2 mb-2 px-4" style={{ fontSize: "15px" }}>
                              <input
                                className="me-2 mt-1"
                                type="checkbox"
                                checked={rememberSelections}
                                onChange={(e) => {
                                  handleRememberSelections(e.target.checked);
                                }}
                              />
                              Remember my selections on this device (optional)
                            </p>
                          </>
                        ) : (
                          <div class="border rounded p-2 ask-main">
                            <div class="ask-expiration d-flex flex-column justify-content-start">
                              <h5 style={{
                                fontWeight: 700
                              }}>
                                Sign up to buy or sell
                              </h5>
                              <p style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }} class="mb-0">
                                Required to place bids/asks and complete checkout
                              </p>
                            </div>
                          </div>
                        )
                      }
                </div>
              )}

                {
                  loggedInUser ? (
                    <div className="d-flex align-items-start mt-5">

                      {!Show && (
                        <Button
                          className="text-capitalize border rounded bg-transparent text-black"
                          onClick={() => handleback()}
                        >
                          back
                        </Button>
                      )}

                      {(!isAdmin && shippingrates == undefined && prams.buy == undefined) || Show ? (
                        <Button
                          className="text-capitalize ms-auto bg-dark text-white border-0 w-100"
                          onClick={() => handleReviewAsk()}
                          disabled={value <= 0 || salesTaxLoader || shiploader}
                        >
                          Review Bid
                        </Button>
                      ) : prams.buy != undefined ? (
                        <Button
                          className="text-capitalize ms-auto bg-dark text-white border-0"
                          disabled={value <= 0 || isLoading || salesTaxLoader || shiploader}
                          onClick={() => {
                            setLoading(true);
                            handlePlaceOrder();
                          }}
                        >
                          {isLoading ? "Please Wait..." : "Place Order"}
                        </Button>
                      ) : (
                        <Button
                          className="text-capitalize ms-auto bg-dark text-white border-0"
                          disabled={isLoading || salesTaxLoader || shiploader}
                          onClick={() => hendleBid()}
                        >
                          {isLoading ? "Please Wait..." : "Place Bid"}
                        </Button>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex align-items-center mt-3">
                      <Button
                        className="text-capitalize ms-auto bg-dark text-white border-0 w-100"
                        onClick={() => {

                          const bidSummary = {
                            bidAmount: value ?? 0,
                          };

                          localStorage.setItem("bidSummary", JSON.stringify(bidSummary));

                          setShowModal(true);
                          setSignup(true);
                          setForgot(false);
                        }} 
                      >
                        Sign Up
                      </Button>
                    </div>
                  )
                }

              {/* Start Login Model */}
                <Login
                  forgot={forgot}
                  setForgot={setForgot}
                  signup={signup}
                  setSignup={setSignup}
                  modal={() => setShowModal(false)}
                  show={showModal}
                  setShow={setShowModal}
                   windowEvent={true}
                />

                {/* Start Card Model */}
                <Modal
                show={showCardModel}
                onHide={() => setShowCardModel(false)}
                backdrop={true}
                keyboard={false}
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Card Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable-modal-body">
                  {localStorage.getItem("tokenuser") ? (
                    <StripeElement
                      id={
                        JSON.parse(localStorage.getItem("tokenuser")).id
                          ? JSON.parse(localStorage.getItem("tokenuser")).id
                          : ""
                      }
                      modalClose={() => setShowCardModel(false)}
                      productId={props.productId}
                      cardBrand={cardBrand}
                    />
                  ) : localStorage.getItem("admin") ? (
                    <StripeElement
                      id={
                        JSON.parse(localStorage.getItem("admin")).id
                          ? JSON.parse(localStorage.getItem("admin")).id
                          : ""
                      }
                      productId={props.productId}
                      modalClose={() => setShowCardModel(false)}
                      cardBrand={cardBrand}
                    />
                  ) : (
                    ""
                  )}
                </Modal.Body>
              </Modal>

              <Modal
                show={popup}
                onHide={() => setPopup(false)}
                backdrop={true}
                keyboard={false}
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Address Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable-modal-body">
                  please fill your address first
                </Modal.Body>
              </Modal>
            </div>

              {/* Start Shipping Address */}
              <Modal
                show={showAddressModal}
                onHide={() => setShowAddressModal(false)}
                backdrop={true}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Update Address</Modal.Title>
                </Modal.Header>

                <Modal.Body className="scrollable-modal-body">
                  {/* Address Field */}
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your Address"
                      value={validStreet}
                      onChange={(e) => setValidStreet(e.target.value)}
                    />
                  </Form.Group>

                  {/* City Field */}
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your City"
                      value={validCity}
                      onChange={(e) => setValidCity(e.target.value)}
                    />
                  </Form.Group>

                  {/* State Dropdown */}
                  <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                    <Form.Select
                      ref={stateRef}
                      aria-label="Select State"
                      value={validState}
                      onChange={(e) => setValidState(e.target.value)}
                    >
                      <option value="">Select State</option>
                      {states?.map((item) => (
                        <option key={item.abbreviation} value={item.abbreviation}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      value="United States"
                      readOnly
                      disabled
                    />
                  </Form.Group>

                  {/* Postal Code */}
                  <Form.Group className="mb-3">
                    <Form.Label>Postal Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your Postal Code"
                      value={validPostalCode}
                      onChange={(e) => setValidPostalCode(e.target.value)}
                    />
                  </Form.Group>

                  {/* Phone Number */}
                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <InputMask
                      className="form-control"
                      mask="(999) 999-9999"
                      placeholder="(123) 456-7890"
                      type="tel"
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                    />
                  </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowAddressModal(false);
                      fetchAndSetUserData();
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    disabled={buttonAddressLoader}
                    onClick={handleUpdateAddress}
                  >
                    {buttonAddressLoader ? "Please Wait..." : "Save"}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={primaryAccountModel}
                size="lg"
                onHide={() => setPrimaryAccountModel(false)}
                backdrop={true}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Update Primary Payment Account</Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable-modal-body">
                  <StripeElement cardBrand={cardBrand} />
                </Modal.Body>
              </Modal>
            {/* Model End Primary Payment Account */}
          </Tab>
        </Tabs>
      )}
    </>
  );
}

export default UncontrolledExample;
